// extracted by mini-css-extract-plugin
export var labelWrapper = "_i3-0";